import { CalendarDays, ChevronDown } from 'lucide-react'
import { useEventContext } from '../contexts/EventContext'

export function EventSwitcher() {
  const { events, selectedEvent, selectEvent } = useEventContext()
  return <label className="event-switcher">
    <CalendarDays size={17} />
    <select aria-label="Salon sélectionné" value={selectedEvent?.id ?? ''} onChange={(event) => selectEvent(event.target.value)}>
      {events.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
    </select>
    <ChevronDown size={15} />
  </label>
}
